/**
 * 媒体 URL 解析（纯函数，两端共用，任务 8d；规则见 protocol §10）。
 *
 * 消息/资料里的图片路径一律存**相对路径**（含 bucket，如 `/imdata/image/...`——
 * 服务端下发前会剥掉自家域名前缀），展示时拼 `config.Cdn`。绝对 URL
 * （http/https/data/blob）原样返回——旧版 resolve() 同口径。
 * 发送前的反向规则 stripMediaDomain（绝对→相对）见下（任务 12a）。
 */
export function resolveMediaUrl(cdnBase: string, path: string): string {
  if (!path) return '';
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  // cdn 未就绪（config 未回包）：返回空串，调用方渲染占位态
  if (!cdnBase) return '';
  const base = cdnBase.endsWith('/') ? cdnBase.slice(0, -1) : cdnBase;
  return path.startsWith('/') ? base + path : `${base}/${path}`;
}

/**
 * 发送/入库前的反向规则（旧版 stripDomain 同口径，任务 12a）：绝对 http(s) URL
 * 取 path(+query) 转相对路径（后端下发前也会剥自家域名，两边域名可能不同，
 * protocol §10.1——所以按 URL 结构剥，不做域名白名单匹配）。相对路径原样返回；
 * blob:/data: 不是可入库的地址，调用方负责不把它们送进来，这里原样透传兜底。
 */
export function stripMediaDomain(raw: string): string {
  const value = raw.trim();
  if (!/^https?:\/\//i.test(value)) return value;
  try {
    const u = new URL(value);
    // 旧版口径：解不出 path 时原样返回（裸域名不是媒体地址）
    if (!u.pathname || u.pathname === '/') return value;
    return u.pathname + u.search;
  } catch {
    return value;
  }
}
